// The in-call ledger: what the coach has heard so far, one entry per InfoMap
// fact key (lists: one entry per item). The Durable Object stores it; the
// brain merges coach updates into it; at the end it seeds the package facts
// (and becomes the facts outright in the "ledger_only" degraded path, design
// 8.2). Same statuses and evidence shape as the package.
import { z } from "zod";
import { Evidence, FactStatus } from "./package";

export const LedgerEntry = z.strictObject({
  key: z.string().regex(/^[a-z][a-z0-9_]{0,63}$/),
  status: FactStatus,
  /** The owner's words, short. */
  answer: z.string().max(240).nullable(),
  /** For list facts, the one item this entry holds. */
  item: z.string().max(240).nullable(),
  evidence: z.array(Evidence),
  confidence: z.enum(["stated", "inferred"]),
  /** Transcript index of the owner turn that last changed this entry. */
  updated_at_i: z.number().int().min(0),
});
export type LedgerEntry = z.infer<typeof LedgerEntry>;

export const Ledger = z.array(LedgerEntry);
export type Ledger = z.infer<typeof Ledger>;
